var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoVehicleInfoWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3418 19.7262H5.5L8.78941 12.5644C9.57575 10.8517 11.1938 9.76855 12.9654 9.76855H28.8769C30.648 9.76855 32.266 10.8517 33.0529 12.5644L36.3418 19.7262Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4828 32.8797H4.11723C2.39552 32.8797 1 31.5995 1 30.02V23.2956C1 21.7161 2.39552 20.4353 4.11723 20.4353H37.4828C39.2045 20.4353 40.6 21.7161 40.6 23.2956V30.02C40.6 31.5995 39.2045 32.8797 37.4828 32.8797Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39912 32.8796V35.7175C9.39912 37.3215 8.12367 38.6222 6.54954 38.6222C4.9754 38.6222 3.69995 37.3215 3.69995 35.7175V32.8796",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2114 32.8796V35.7175C38.2114 37.3215 36.9354 38.6222 35.3618 38.6222C33.7882 38.6222 32.5122 37.3215 32.5122 35.7175V32.8796",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73457 26.1489C9.73457 27.3408 8.78659 28.3071 7.61729 28.3071C6.44798 28.3071 5.5 27.3408 5.5 26.1489C5.5 24.957 6.44798 23.9907 7.61729 23.9907C8.78659 23.9907 9.73457 24.957 9.73457 26.1489Z",
    fill: "#FFD4A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3415 26.1489C36.3415 27.3408 35.3935 28.3071 34.2242 28.3071C33.0549 28.3071 32.1069 27.3408 32.1069 26.1489C32.1069 24.957 33.0549 23.9907 34.2242 23.9907C35.3935 23.9907 36.3415 24.957 36.3415 26.1489Z",
    fill: "#FFD4A3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3423 27.9281C21.1787 25.474 21.7105 23.6333 22.9376 22.4063C24.7782 20.5656 24.3648 21.2705 26.6188 18.725C28.8728 16.1795 30.3 15.0438 30.3 12.4072C30.3 7.4645 26.2752 4 21.1215 4C15.8205 4 11.8938 7.74166 11.8938 12.4534",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0969 33.45V37.1312",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVehicleInfoWeight);
export default __webpack_public_path__ + "static/media/ico_vehicle_info_weight.a6c970952a15afc9c8621576caa53ee9.svg";
export { ForwardRef as ReactComponent };